import { computed, ref } from 'vue';
import { defineStore } from 'pinia';
import { useApi } from '@/composables/useApi';
import { useRoute } from 'vue-router';

export const useKioskStore = defineStore('kiosk', () => {
	const { request } = useApi();
	const route = useRoute();

	const kioskId = ref(null);
	const accountId = ref(null);
	const branchId = ref(null);
	const timeout = ref(60);
	const isEmbed = ref(false);
	const locale = ref(route.query.lang || 'en');

	const currency = computed(() => locale.value === 'en' ? 'czk' : 'Kč');

	async function fetchKiosk(uid){
		kioskId.value = uid;

		const data = await request(`/api/${uid}/kiosk`);

		accountId.value = data?.aid;
		branchId.value = data?.bid;
		timeout.value = data?.appTimerTime || 60;
	}

	async function getKioskStatus() {
		const date = Date.now();
		const options = {
			headers: {
				'BSS-SENDER-ID': 'kiosk',
				'BSS-KIOSK-ID': kioskId.value
			}
		}


		await request(`/api/transaction/status?${date}`, options);
		await request(`/api/transaction/message?${date}`, options);
	}

	return {
		kioskId,
		accountId,
		branchId,
		timeout,
		isEmbed,
		locale,
		currency,
		fetchKiosk,
		getKioskStatus
	};
});

